import { User } from 'src/app/shared/models/user';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService:AuthService){}
  async canActivate (
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot){//: Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree | Promise {
    
    //   let isAuthenticated=false;
    // this.authService.user$.subscribe(user=>{
    //   isAuthenticated = (user && user.uid)!=null;
    // });
     let user = await this.authService.user$.pipe(take(1)).toPromise();
     let isAuthenticated = !!(user && user.uid);


    console.log('Autenticado', isAuthenticated);

    if (!isAuthenticated){
      isAuthenticated = await this.authService.loginWithEmailLink();
      
    }
    return isAuthenticated;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
